import { useCallback, useMemo, useRef, useState } from "react";
import type { BotProtectionFields } from "@tih/shared";
import { turnstileRequired, usePublicConfig } from "./usePublicConfig";

export function useBotProtection() {
  const config = usePublicConfig();
  const [website, setWebsite] = useState("");
  const [turnstileToken, setTurnstileToken] = useState<string | undefined>();
  const resetTurnstileRef = useRef<(() => void) | null>(null);

  const needsTurnstile = turnstileRequired(config);
  const ready = !needsTurnstile || Boolean(turnstileToken);

  const botFields = useMemo<BotProtectionFields>(
    () => ({
      website,
      ...(turnstileToken ? { turnstileToken } : {}),
    }),
    [website, turnstileToken],
  );

  const onTurnstileToken = useCallback((token: string) => {
    setTurnstileToken(token);
  }, []);

  const onTurnstileExpire = useCallback(() => {
    setTurnstileToken(undefined);
  }, []);

  const registerTurnstileReset = useCallback((reset: () => void) => {
    resetTurnstileRef.current = reset;
  }, []);

  const resetBotProtection = useCallback(() => {
    setTurnstileToken(undefined);
    resetTurnstileRef.current?.();
  }, []);

  return {
    config,
    needsTurnstile,
    ready,
    website,
    setWebsite,
    botFields,
    onTurnstileToken,
    onTurnstileExpire,
    registerTurnstileReset,
    resetBotProtection,
  };
}
